module.exports = __webpack_public_path__ + "ace230207c540cca8fcd9f7d0d9c9a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/address-info/icon-telephone.png
// module id = ./src/components/address-info/icon-telephone.png
// module chunks = index